import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import { Paper } from 'material-ui';
import withTranslation from '../../../hoc/withTranslation';
import { fetchApp } from '../../../store/apps/actions';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import style from '../../../styles/styles';
import { dispatchInfo } from "../../../store/infos/actions";
import AchievementForm from '../../../components/achievement/AchievementForm/AchievementForm';
import { postAchievement } from '../../../store/achievements/actions';
import { ACHIEVEMENT_PAGE } from '../../../constants/routes';
import CustomFieldService from '../../../services/customfield';
import { getCustomFields } from '../../../store/customfields/actions';

export class AddAchievementPage extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string,
        achievementsSending: PropTypes.bool,
        t: PropTypes.func,
        postAchievement: PropTypes.func,
        getCustomFields: PropTypes.func,
        customFields: PropTypes.arrayOf(PropTypes.object),
    };

    state = {
        shouldCreateNew: false,
        acquisitionType: 'point',
    }

    componentWillMount() {
        this.fetchApplication(this.props.match.params.appId);
    }

    componentWillReceiveProps(nextProps) {
        if ((
            this.props.match !== nextProps.match || !this.props.app
        ) && !nextProps.appPending) {
            this.fetchApplication(this.props.match.params.appId);
        }
        if (nextProps.app && !nextProps.customFields) {
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.achievementsSending && !nextProps.achievementsSending) {
            if (this.state.shouldCreateNew) {
                nextProps.dispatchInfo(nextProps.t('module.gamification.achievement_saved'));
            } else {
                this.props.history.push(
                    ACHIEVEMENT_PAGE
                        .replace(':appId', nextProps.app.id)
                        .replace(':achievementId', nextProps.currentAchievement.id)
                );
            }
        }

        if (this.state.shouldCreateNew) {
            this.setState({shouldCreateNew: false});
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    handleFormReset = () => {
        this.setState({
            title: null,
            shouldCreateNew: true
        });
    }

    handleFormSubmit = async (formProps) => {
        if (formProps === null) {
            return;
        }
       await this.props.postAchievement(this.props.app, formProps, this.props.currentLang)
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.appPending || !this.props.app) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>
                        {this.props.t('module.gamification.achievements')} / {this.props.t('generic.add')} - {this.props.app.name}
                    </h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.gamification.new_achievement')}
                                </Subheader>
                                <div style={style.paper}>
                                    <AchievementForm
                                        app={this.props.app}
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.achievementsSending}
                                        onFormReset={this.handleFormReset}
                                        customFields={CustomFieldService.filter(this.props.customFields,
                                            CustomFieldService.ACHIEVEMENT,
                                        )}
                                        defaultAcquisitionType={this.state.acquisitionType}
                                    />
                                </div>
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        appPending: state.apps.pending,
        error: state.apps.error || state.achievements.error,
        app: state.apps.currentApplication,
        currentAchievement: state.achievements.currentAchievement,
        achievementsSending: state.achievements.sending,
        currentLang: state.ui.currentLang,
        user: state.auth.content,
        customFields: state.customFields.content,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    return props;
}

export default connect(
    mapStateToProps,
    {
        fetchApp,
        postAchievement,
        dispatchInfo,
        getCustomFields
    },
)(withRouter(withTranslation(AddAchievementPage)));



// WEBPACK FOOTER //
// src/containers/gamification/AddAchievementPage/AddAchievementPage.js